/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmployeesEmployeesEmployeeModel } from './employees-employees-employee-model';

/**
 * Candidate for the position of a position request
 */
export interface HeadcountApprovalPositionRequestCandidatePositionRequestCandidateModel {
  /**
   * Type of candidate: external or internal
   */
  type?: HeadcountApprovalPositionRequestCandidatePositionRequestCandidateModelTypeEnum;
  /**
   * Possible employee id of candidate
   */
  employeeId?: string | null;
  employee?: EmployeesEmployeesEmployeeModel;
  /**
   * Possible full name of candidate
   */
  fullName?: string | null;
  /**
   * Possible gid of candidate
   */
  gid?: string | null;
}
export enum HeadcountApprovalPositionRequestCandidatePositionRequestCandidateModelTypeEnum {
  Internal = 'Internal',
  External = 'External'
}
